// https://tylermcginnis.com/validate-email-address-javascript/

function emailIsValid (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export default emailIsValid;
